<div class="w-full py-2 px-4 tui-base-01-bg">
  <df-tactic-settings-header [isPublic]="true"></df-tactic-settings-header>
</div>
<df-tactic-settings [isPublic]="true"></df-tactic-settings>
